'use strict';

export class ProfileAds {
    constructor(component_key) {
        this.id = component_key;
        this.data = yalwa.v.components[component_key];
        this.$root = jQuery(`.js-${this.id}`);
        this.$container = this.$root.find('.js-postings-wrapper');
        this.$searchForm = this.$root.find('.js-search-form');
    }

    init() {
        // Sidebar Navigation
        this.$root.on('click', '.js-category-link', (e) => this.handleCategoryClick(e));

        // Search Handlers
        this.$root.on('submit', '.js-search-form', (e) => {
            e.preventDefault();
            this.handleAction('submit');
        });

        this.$root.on('click', '.js-search-submit', (e) => {
            e.preventDefault();
            this.handleAction('submit');
        });
    }

    handleCategoryClick(e) {
        e.preventDefault();
        const $link = jQuery(e.currentTarget);
        
        // Update visual state
        this.$root.find('.js-category-link').removeClass('active');
        $link.addClass('active');

        // Clear search input on category change
        this.$root.find('.js-search-input').val('');

        const params = {
            grp: $link.data('grp'),
            cat: $link.data('cat'),
            search: ''
        };

        this.fetchData(params);
    }

    handleAction(type) {
        const $activeCat = this.$root.find('.js-category-link.active');
        const params = {
            search: this.$root.find('.js-search-input').val(),
            grp: $activeCat.data('grp'),
            cat: $activeCat.data('cat')
        };
		
        this.fetchData(params);
    }

    fetchData(params) {
        // Construct the payload to match ajax_service_publicprofile requirements
        const payload = {
            emailIDs: this.data.email_ids, // This must be an array
            userID_viewed: this.data.userID_viewed,
            nickname: this.data.nickname,
            ycomponent: true
        };

        // Merge in filters
        if (params.grp && params.grp !== 'all') payload.grp = params.grp;
        if (params.cat) payload.cat = params.cat;
        if (params.search) payload.search = params.search;

        yalwa.basics.ajaxservice({
            type: 'POST',
            resource: 'publicprofile',
            action: 'category',
            data: payload,
            csrf: this.data.csrf_token
        }).then(response => {
            if (response.success) {
                // Update the postings container with new HTML
                this.$container.html(response.html);
                
                // Re-init any trackers or lazy loading if necessary
                if (yalwa.mobile.mark_new_postings) {
                    yalwa.mobile.mark_new_postings();
                }

                if (yalwa.mobile.matches_breakpoint('desktop')) {
                    jQuery('html, body').animate({ scrollTop: 0 }, 400);
                }
            }
        }).catch(err => {
            console.error('ProfileAds AJAX error:', err);
        });
    }
}

// Global initialization
Object.keys(yalwa.v.components).forEach(key => {
    if (key.startsWith('profileads_')) {
        new ProfileAds(key).init();
    }
});